import { FC } from "react";
import { UserJourneyModule } from "./UserJourneyBloc";
import Spacer from "./Spacer";
import styled from "@emotion/styled";

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2rem;
  margin-top: 2rem;
  min-height: 18rem;

  &[data-first="true"] {
    margin-top: 0;
  }
`;

const ContentWrapper = styled.div`
  margin-top: auto;
  margin-bottom: auto;
  padding-bottom: 2rem;

  &[data-first="true"] {
    padding-bottom: 0;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const EclipseSVG: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 10"
    preserveAspectRatio="none"
    style={{ width: "100%", height: "2rem" }}
  >
    <path d="M 0 10 Q 50 0, 100 10" fill="var(--color-cream)" stroke="none" />
  </svg>
);

const HeaderBackground = styled.div`
  position: absolute;
  height: 100%;
  width: 100vw;

  --bg-size: 100% 200%;
  background-repeat: no-repeat;
  z-index: -2;
  background-size: var(--bg-size);
  background-position-y: var(--bg-position-y);
  background-image: var(--journey-module-header-bg-gradient);

  &[data-color-scheme="sunrise"] {
    --bg-size: 100% 600%;
    --bg-position-y: center;
  }

  &[data-color-scheme="fierceSundown"] {
    --bg-size: 100% 100%;
  }

  &[data-color-scheme="hazySundown"] {
    --bg-size: 100% 300%;
  }
`;

const GradientBlock = styled.div`
  position: absolute;
  z-index: -1;
  height: 4rem;
  width: 100vw;
  background: linear-gradient(
    0,
    rgba(42, 123, 155, 0) 0%,
    var(--color-cream) 100%
  );

  &[data-first="true"] {
    display: none;
  }
`;

const EclipseWrapper = styled.div`
  position: absolute;
  width: 100vw;
  height: 2rem;
  bottom: 0;
`;

interface JourneyModuleHeaderProps {
  module: UserJourneyModule;
  first?: boolean;
}

export const JourneyModuleHeader: FC<JourneyModuleHeaderProps> = ({
  module,
  first = false
}) => {
  return (
    <Container data-first={first}>
      <GradientBlock data-first={first} />
      <HeaderBackground data-color-scheme={module.theme} />
      <ContentWrapper data-first={first}>
        {!first && <Spacer colorScheme={module.theme} />}

        <TitleContainer>
          <h2>{module.name}</h2>
          <span>{module.subtitle}</span>
        </TitleContainer>
      </ContentWrapper>

      <EclipseWrapper>
        <EclipseSVG />
      </EclipseWrapper>
    </Container>
  );
};
